import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import ImgErxIllustration from '../../../../../../public/images/illustrations/illustration-erx.png'
import { useGlobalConfigContext } from '../../../../../global-config'
import { StaticImage } from '../../../../../image'
import { urlResolverGetRedeemEprescription } from '../../../../../url-handling'
import { erxBonusLandingPageTextAccent } from '../../../../components/ErxBonusLandingPageTranslationValues'

export const ErxBonusLandingPageFaqHowToCard: FC = () => {
  const globalConfig = useGlobalConfigContext()

  return (
    <div className="flex flex-col items-start rounded-3xl bg-light-secondary-medium p-4 px-5 tablet:mx-0">
      <div className="flex flex-col">
        <div className="mb-2 flex items-center">
          <StaticImage
            alt="Gkv Rezept"
            className="mr-2 tablet:w-1/3"
            height={64}
            src={ImgErxIllustration}
            width={91}
          />

          <span className="text-2xl font-medium leading-xl text-dark-primary-max">
            <FormattedMessage
              id="deErx.oldBonus.landingPageFaq.processCard.title"
              values={{
                accentuate: erxBonusLandingPageTextAccent,
              }}
            />
          </span>
        </div>

        <div className="flex flex-col items-center justify-center text-s text-dark-primary-strong">
          <span className="mb-4 text-dark-primary-max">
            <FormattedMessage
              id="deErx.oldBonus.landingPageFaq.processCard.description"
              values={{
                accentuate: erxBonusLandingPageTextAccent,
              }}
            />
          </span>

          <Button<'a'>
            className="w-full whitespace-nowrap text-s text-light-primary-strong"
            color="primary"
            href={urlResolverGetRedeemEprescription(globalConfig)}
            slots={{ root: 'a' }}
            variant="filled"
          >
            <FormattedMessage id="erx-banner.btn" />
          </Button>
        </div>
      </div>
    </div>
  )
}
